import { PropsWithChildren } from 'react';
import styles from './Table.module.css';

type Props = PropsWithChildren;

export function Caption({ children }: Props) {
  return (
    <caption>
      <div className={styles.caption}>{children}</div>
    </caption>
  );
}
